import React from "react";

interface DisclosuresDtoProps {
    className?: string;
}

const DisclosuresDto = ({ className = "" }: DisclosuresDtoProps) => {
    const references = [
        {
            number: 1,
            text: "The definition of Spouse is determined by your state's law.",
        },
        {
            number: 2,
            text: '"2024 Facts About Life - Workplace Benefits," LIMRA, ',
            link: "https://www.limra.com/siteassets/newsroom/liam/2024/2024-liam-wpb-fact-sheet",
        },
        {
            number: 3,
            text: '"Economic Well-Being of U.S. Households in 2024" Board of Governors of the Federal Reserve System, May 2025, ',
            link: "https://www.federalreserve.gov/publications/files/2024-report-economic-well-being-us-households-202505.pdf",
        },
        {
            number: 4,
            text: '"Life Insurance Awareness Month: A Time to Help More Consumers Get the Life Insurance Coverage They Say They Need," LIMRA, ',
            link: "https://www.limra.com/en/newsroom/industry-trends/2024/life-insurance-awareness-month-a-time-to-help-more-consumers-get-the-life-insurance-coverage-they-say-they-need/",
        },
    ];

    const legalDisclaimer =
        "Life insurance underwritten by AAA Life Insurance Company, Livonia, MI. Product features and benefits may vary by state. For complete details, please refer to the Certificate provisions and Group Master Policy.";

    return (
        <div id="disclosures" className={`w-full py-6 tablet:py-12 px-6 ${className}`} style={{ backgroundColor: "#F2F1F0" }}>
            <div className="max-w-4xl mx-auto">
                <div className="space-y-6">
                    <div className="space-y-3">
                        {references.map((reference) => (
                            <div key={reference.number} className="flex items-start space-x-3">
                                <span className="text-base-content font-sans font-medium text-base leading-6 flex-shrink-0">
                                    {reference.number}.
                                </span>
                                <p className="text-base-content font-sans font-medium text-base leading-6 break-words">
                                    {reference.text}
                                    {reference.link && (
                                        <a
                                            href={reference.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 hover:text-blue-800 underline ml-1 break-all"
                                        >
                                            {reference.link}
                                        </a>
                                    )}
                                </p>
                            </div>
                        ))}
                    </div>
                    <div className="pt-4  border-gray-400">
                        <p className="text-base-content font-sans font-medium text-base leading-6">{legalDisclaimer}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DisclosuresDto;
